import { Route, Routes } from "react-router";

import Flashcards from "./pages/flashcards";
import HomePage from "./pages/home-page.tsx";
import Layout from "./pages/layout.tsx";
import QuizPage from "./pages/quiz";

const Router = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="/app">
          <Route index element={<HomePage />} />
          <Route path="flashcards">
            <Route path=":flashcards_id" element={<Flashcards />} />
          </Route>
          <Route path="quiz">
            <Route path=":quiz_id" element={<QuizPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default Router;
